import DashBoard from "../../barista/dashboard/dashboard_page";

// Admin gets the same cafe dashboard as barista, plus the Top Customers
// section that's gated behind showCustomers.
function DashboardAdmin() {
  return <DashBoard showCustomers />;
}

export default DashboardAdmin;
